import * as React from 'react';
import { makeStyles, Theme } from '@material-ui/core';
import TextStyles from '../theme/text';
import { neutral } from '../theme/colors';
import { DataGridColumn, DataGridData } from './models';
import DataGridRow from './data-grid-row';
import DataGridCell from './data-grid-cell';

export interface DataGridProps {
  data: DataGridData;
  /** if fetching trends, an access token to send with requests to the api */
  accessToken?: any;
}

const useStyles = makeStyles<Theme, { columns: DataGridColumn[] }>({
  root: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: ({ columns }) =>
      columns
        .map(({ title, maxWidth }) => `minmax(max-content, ${maxWidth ? maxWidth : '1fr'})`)
        .join(' '),
    gridTemplateRows: '28px',
    borderBottom: `2px solid ${neutral[400]}`,
    '& > div': {
      overflowY: 'hidden',
      '&:first-child': {
        paddingLeft: 34
      }
    }
  },
  headerCell: {
    ...TextStyles.label1,
    textTransform: 'uppercase',
    '& p': {
      margin: 0
    }
  }
});

/**
 * Component to render a data grid: A table-like collapsible tree view.
 */
const DataGrid = ({ data, accessToken }: DataGridProps) => {
  const classes = useStyles({
    columns: data.columns
  });

  return (
    <div className={classes.root}>
      {data.columns.map((column) => (
        <DataGridCell className={classes.headerCell} key={column.title}>
          <p>{column.title}</p>
        </DataGridCell>
      ))}
      {data.rows.map((row, i) => (
        <DataGridRow
          columns={data.columns}
          columnCount={data.columns.length}
          row={row}
          parentCollapsed={false}
          key={`${row.title}-${i}`}
          accessToken={accessToken}
        />
      ))}
    </div>
  );
};

export default DataGrid;
